import http from '../../axios-config/g-http-metodos';

function getLogByFiltro(filtros) {
    const { res, erro, requisicao } = http.postArray(`Log/GetLogByFiltro`, filtros)
    return { LogArray: res , erro, requisicao }
}


function GetEnumDescricaoProcesso(filtros) {
    const { res, erro, requisicao } = http.getArray(`DescricaoProcesso/Get`, filtros)
    return { LogArray: res , erro, requisicao }
}

function GetAllNomesTabelasLog() {
    const { res, erro, requisicao } = http.getArray(`Log/GetAllNomesTabelasLog`)
    return { TabelasArray: res , erro, requisicao }
}

const GerenciamentoLogController = {
    getLogByFiltro,
    GetEnumDescricaoProcesso,
    GetAllNomesTabelasLog
  }
  
  export default GerenciamentoLogController
  